/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable no-unused-expressions */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Formik, Field } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import Layout from 'components/Layout';
import {
  Button,
  ButtonContainer,
  HasPermission,
  ContentCard,
  CheckBox,
  FormSection
} from '@fitinsur/components';
import IMask from 'imask';
import { ButtonContent } from './styles';
import { FitinsurAPI, MessageCenter } from 'utils';
import { GlobalAuthContext } from 'store/context';
import StepNavigation from 'components/StepNavigation'
import moment from 'moment'
import {
  AddButton,
  Content,
  TitleBar,
  TitleInfo,
  TitleAlter,
  OptionSummary,
  OptionSummaryTitle,
  OptionSummaryValue,
  TermsContainer,
  Term,
  StrongTerm,
  TermText
} from './styles';
import Row from "components/Grid/Row";
import Col from "components/Grid/Col";
import BrokingSummary from 'components/BrokingSummary';
import { camelCase, uniqueId } from 'lodash';
import DialogComponent from 'components/Dialog';
import MasksHelper from 'utils/src/masks';
import Icon from 'components/Icon'
import * as yup from 'yup';
import {
  useGetQuestionnaireAnswer,
  useDeleteQuestionnaireAnswer,
  useSaveQuestionnaireAnswer
} from 'services/QuestionnaireAnswerService';
import {
  LoaderContext
} from '@fitinsur/contexts'
import { useGetDocuments } from 'services/DocumentsService';
import { groupMultipleFieldQuestions, onValidationError, removeAnswersDuplicateSession } from 'containers/edit/handleQuestionChange';
import { useGetOperationAsync } from 'services/OperationService';
import { useSaveQuestionsPayments } from 'services/QuestionnaireAnswerService';

export default function EditEnquirity({ permissions, ...props }) {
  const { updateIsLoadingStatus } = useContext(LoaderContext);
  const validationSchema = useRef(yup.object().shape({}));
  const authContext = useContext(GlobalAuthContext);
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();
  const formikRef = useRef({});
  const location = useLocation();
  const handleBack = () => history.goBack();
  const maskHelper = new MasksHelper();
  let executeBindRequest = useRef(false);
  let clientCnpj = useRef("");

  const [isBound, setIsBound] = useState(true);
  const [operation, setOperation] = useState({});
  const [dialogTerms, setDialogTerms] = useState({
    visible: false,
    title: '',
    icon: '',
    args: null,
    questions: []
  });
  const [terms, setTerms] = useState({ authorization: false, termsAndConditions: false })
  const [coverageOption, setCoverageOption] = useState(location?.state?.option == null ? 0 : location?.state?.option)
  const [idProductPlanSelected, setIdProductPlanSelected] = useState(location?.state?.idProductPlanSelected == null ? 0 : location?.state?.idProductPlanSelected)
  const [questionnaire, setQuestionnaire] = useState([])
  const [information, setInformation] = useState([]);
  const [installments, setInstallments] = useState([]);
  const [questionnaireAnswersToDelete, setQuestionnaireAnswersToDelete] = useState([]);
  const [visibleSection, setVisibleSection] = useState(false);
  const [totalInstallments, setTotalInstallments] = useState('');
  const [coverageCalcList, setCoverageCalcList] = useState([{
    coverageCalc: [{
      coverageLimit: 0,
      coverageAmount: 0,
      coverageComissionRate: 0,
      coverageComission: 0,
      coverageTax: 0,
      coverageAmountTaxLess: 0,
      deductibleDescription: "",
      coverageItems: []
    }]
  }])

  const {
    data: useGetQuestionnairesAnswersData,
    loading: useGetQuestionnairesAnswersLoading,
    error: useGetQuestionnairesAnswersError,
    status: useGetQuestionnairesAnswersStatus,
    request: useGetQuestionnairesAnswersRequest,
  } = useGetQuestionnaireAnswer(props.match.params.idOperation);

  const {
    data: useGetDocumentsData,
    loading: useGetDocumentsLoading,
    error: useGetDocumentsError,
    status: useGetDocumentsStatus,
    request: useGetDocumentsRequest
  } = useGetDocuments(props.match.params.idOperation);

  const {
    loading: useGetOperationLoading,
    request: useGetOperationRequest
  } = useGetOperationAsync(props.match.params.idOperation);

  const {
    data: useSaveQuestionnaireAnswerData,
    loading: useSaveQuestionnaireAnswerLoading,
    error: useSaveQuestionnaireAnswerError,
    status: useSaveQuestionnaireAnswerStatus,
    request: useSaveQuestionnaireAnswerRequest,
  } = useSaveQuestionnaireAnswer(props.match.params.idOperation);

  const {
    data: useDeleteQuestionnaireData,
    loading: useDeleteQuestionnaireLoading,
    error: useDeleteQuestionnaireError,
    status: useDeleteQuestionnaireStatus,
    request: useDeleteQuestionnaireAnswerRequest,
  } = useDeleteQuestionnaireAnswer(props.match.params.idOperation);

  const {
    loading: useSaveQuestionsPaymentsLoading,
    request: useSaveQuestionsPaymentsRequest
  } = useSaveQuestionsPayments(props.match.params.idOperation);

  useEffect(() => {
    if (useGetQuestionnairesAnswersStatus === 200) {
      handleQuestionnaire(useGetQuestionnairesAnswersData?.value)
    }
  }, [useGetQuestionnairesAnswersStatus]);

  useEffect(() => {
    if (!useGetDocumentsStatus) return;
    if (useGetDocumentsStatus === 200 && idProductPlanSelected) {
      const [quoteRequestDocument] = useGetDocumentsData.value;

      console.log('quoteRequestDocument', quoteRequestDocument);
      
      if (quoteRequestDocument.documentCoverageList?.coverageCalcList[0]?.coverageCalc) {
        let coverageCalc = quoteRequestDocument.documentCoverageList?.coverageCalcList.find(calc => calc.idProductPlan == idProductPlanSelected).coverageCalc
        setCoverageCalcList(coverageCalc);
      } else {
        setCoverageCalcList(quoteRequestDocument.documentCoverageList?.coverageCalcList);
      }
    }
  }, [useGetDocumentsStatus, idProductPlanSelected])

  useEffect(() => {
    updateIsLoadingStatus(
      useGetQuestionnairesAnswersLoading ||
      useGetDocumentsLoading ||
      useSaveQuestionnaireAnswerLoading ||
      useDeleteQuestionnaireLoading ||
      useSaveQuestionsPaymentsLoading
    )
  }, [
    useGetQuestionnairesAnswersLoading,
    useGetDocumentsLoading,
    useSaveQuestionnaireAnswerLoading,
    useDeleteQuestionnaireLoading,
    useSaveQuestionsPaymentsLoading
  ]);

  console.log('coveCalc', coverageCalcList);

  const SECTIONS = {
    PAYMENT: { name: 'PAYMENT', isMultiple: false, isRisk: false },
    INFORMATION: { name: 'INFORMATION', isMultiple: true, isRisk: false },
    OPERATION_INFO: { name: 'OPERATION_INFO', isMultiple: false, isRisk: false },
    INSURED: { name: 'INSURED', isMultiple: false, isRisk: false },
    PARCELAMENTO: { name: 'PARCELAMENTO', isMultiple: true, isRisk: false }
  };

  const getQuestionUniqueKey = (question, index) => {
    const key = `${camelCase(question.dsQuestion)}${index != null ? `_${index}` : ""}_${uniqueId()}`;
    formikRef.current.setFieldValue(key, question.behaviorObject?.defaultValue || "");
    return key;
  };

  const handleOperationInfo = () => {
    console.log("teste")
    useGetOperationRequest(null, { loadLastDocument: true }).then(response => {
      let operationData;
      if (response.status === 200) {
        operationData = response.data?.value;
        console.log(operationData)
        setOperation(operationData);
        if(operationData.operationMetadata.idProductPlanSelected){
          setCoverageOption(operationData.operationMetadata.coverageOption)
        }else{
          history.push(`/quote/plans/48/${operationData.idOperation}`)
        }
        if(operationData.operationMetadata.idProductPlanSelected){
          setIdProductPlanSelected(operationData.operationMetadata.idProductPlanSelected)
        }else{
          history.push(`/quote/plans/48/${operationData.idOperation}`)
        }
        setIsBound([5, 2, 6].includes(operationData?.idDomainStatus))
      }
    });
  }

  const handleQuestionnaire = async (data) => {
    let questionnaire = [];
    questionnaire = [
      ...data.persons,
      ...data.operations,
      ...data.payments,
      ...data.risks
    ];
    questionnaire = questionnaire.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion);

    questionnaire.map(qst => {
      if (qst.idQuestion === 687 && permissions.NBI_REQUEST_APPROVE_REJECT) qst.behaviorObject.fieldMinValue = -365;
    }) 

    let add_information = groupMultipleFieldQuestions(726, questionnaire, operation, isBound);

    add_information = add_information.map(group => {
      group.map(question => {
        if (question.idQuestion === 690) question.disabled = true;
        return question;
      });

      return group;
    });

    clientCnpj.current = questionnaire.find(qst => qst.idQuestion === 658)?.answer;

    let total = 0;
    let mask = null;
    const installmentGroups = groupMultipleFieldQuestions(
      1217,
      questionnaire,
      operation,
      isBound
    ).map(group => {
      group.map(qst => {
        if (qst.idQuestion === 1217 && qst.answer) setVisibleSection(true);

        if (qst.idQuestion === 1218 && qst.answer) {
          if (!mask) mask = qst.fieldMask
          total += parseFloat(qst.answer);
        }

        if (qst.idQuestion === 1219) qst.visibleQuestion = false;
        qst.disabled = true;
        qst.behaviorObject.desktopWidth = 50;
        return qst;
      });
      return group
    });

    if (mask && total > 0) {
      const masked = IMask.createMask(mask);
      setTotalInstallments(
        `R$ ${masked.resolve(String(total).replace('.', ','))}`
      );
    }

    setInstallments(installmentGroups)
    setQuestionnaire(questionnaire);
    setInformation(add_information);
  }

  useEffect(() => {
    if (useSaveQuestionnaireAnswerStatus === 200) {
      useDeleteQuestionnaireAnswerRequest({ ids: questionnaireAnswersToDelete });
    }
  }, [useSaveQuestionnaireAnswerStatus]);

  useEffect(() => {
    if (useDeleteQuestionnaireStatus === 200) {
      useGetQuestionnairesAnswersRequest();
      if (executeBindRequest.current) {
        useSaveQuestionsPaymentsRequest({
          questionnaire: { coverageOptionSelected: coverageOption, idProductPlan: idProductPlanSelected },
          coverageOptionSelected: coverageOption,
          idProductPlan: idProductPlanSelected,
          isDraft: false
        }).then((response) => {
          if (response.status === 200) {
            mc.success("Seguro enviado para emissão.");
            history.push(`/list`);
          } else {
            mc.error("Ocorreu um erro durante a solicitação.");
          }
        })
      }
    }
  }, [useDeleteQuestionnaireStatus]);

  const buildValidation = () => {
    const validationSchema = {};

    const fieldErrorMessage = (question) => {
      formikRef.current.isSubmitting && mc.error(`O Campo: ${question.dsQuestion} é Obrigatório`);
      return "* Campo Obrigatório"
    };

    const questionnaire = handleSaveQuestionnaireAnswer(formikRef?.current?.values, false, true);
    for (const question of questionnaire) {
      if (!question.key) continue;
      if (!question?.behaviorObject?.sectionName || !SECTIONS[question?.behaviorObject?.sectionName]) continue;

      validationSchema[question.key] = question.visibleQuestion && question.behaviorObject?.isRequired
        ? yup.string().required(() => fieldErrorMessage(question))
        : yup.string().notRequired();
    }

    return yup.object().shape(validationSchema);
  }

  const hire = async (values, isDraft) => {
    try {
      if (!isDraft && (!terms.authorization || !terms.termsAndConditions)) {
        mc.error("É necessario confirmar que revisou os dados preenchidos e concordar com os Termos e Condições");
        return;
      };

      if (isDraft) {
        handleSaveQuestionnaireAnswer(values, props.match.params.idOperation);
      } else {
        buildValidation().validate(values, { abortEarly: false })
          .then(() => {
            handleSaveQuestionnaireAnswer(values, props.match.params.idOperation);
          })
          .catch((e) => {
            onValidationError(e, mc, formikRef, questionnaire, [...information])
          })
      }

      executeBindRequest.current = !isDraft;
    } catch (e) {
      updateIsLoadingStatus(false);
      mc.error(`Ocorreu um erro durante a solicitação.`);
      console.log("hire error", e);
    }
  }

  const renderAddAndRemoveButtons = (array, index, questions, setFunction, partySectionName, values) => {
    return (
      <>
        {index !== 0 ?
          <AddButton onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            setFunction(array.filter((v, i) => i !== index));
          }}>
            <Icon name="trash" />
          </AddButton> : <></>}
        {partySectionName === '$ANSWERS_CO-PERSON-EXG' && array.length === 3 ? <></> : index === array.length - 1 ?
          <AddButton onClick={(e) => {
            e.preventDefault(); e.stopPropagation();
            setFunction([...array, removeAnswersDuplicateSession(questions)]);
          }}>
            <Icon name="plus" />
          </AddButton> : <></>}
      </>
    )
  }

  const handleSearchClientAddress = async (searchValue) => {
    updateIsLoadingStatus(true);
    fitinsur.setAuthToken(authContext.token);
    const clientAdress = fitinsur.requestSerproCnpj(maskHelper.normalizeValue(searchValue))
      .then(response => response.json())
      .then(data => {
        if (data.ret_code !== 200) {
          data.ret_value.trim() === "Nenhum registro encontrado."
            ? mc.error(`${data.ret_value}`)
            : mc.error("Erro durante a Consulta do CNPJ/CPF")

          return "";
        }
        return data.ret_value.endereco;
      })
      .finally(() => updateIsLoadingStatus(false));

    return clientAdress;
  }

  const handleSearchZipCode = async (zipCodeData, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
    try {
      filteredQuestionnaire = filteredQuestionnaire.map(question => {
        if (question.idQuestion === 667) {
          console.log(question.idQuestion, zipCodeData.LONG_STREET_NAME)
          setFieldValue && setFieldValue(question.key, zipCodeData.LONG_STREET_NAME);
          return ({ ...question, answer: zipCodeData.LONG_STREET_NAME });
        }

        if (question.idQuestion === 666) {
          zipCodeData.ZIP_CODE = `${zipCodeData.ZIP_CODE}`.padStart(8, '0');
          setFieldValue && setFieldValue(question.key, String(zipCodeData.ZIP_CODE));
          return ({ ...question, answer: String(zipCodeData.ZIP_CODE) });
        }

        if (question.idQuestion === 670) {
          console.log(question.idQuestion, zipCodeData.CITY)
          setFieldValue && setFieldValue(question.key, zipCodeData.CITY);
          return ({ ...question, answer: zipCodeData.CITY });
        }

        if (question.idQuestion === 671) {
          console.log(question.idQuestion, zipCodeData.STATE)
          setFieldValue && setFieldValue(question.key, zipCodeData.STATE);
          return ({ ...question, answer: zipCodeData.STATE });
        }

        return question;
      })

      setFilteredQuestionnaire(filteredQuestionnaire);
    } catch (error) {
      console.log('handleSearchZipCode error', error)
    }
  };

  const handleInformationSection = async (questionRoot, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
    try {
      const coverageComissionRate = coverageCalcList[coverageOption]?.coverageComissionRate;

      if (questionRoot.idQuestion === 691) {
        setFilteredQuestionnaire(filteredQuestionnaire.map(question => {
          if (question.idQuestion === 690) {
            if (answer) {
              const calc = String((Number(answer) * coverageComissionRate));
              question.answer = calc;

              setFieldValue && setFieldValue(question.key, calc);
            } else {
              setFieldValue && setFieldValue(question.key, '');
            }
          }

          return question;
        }));
      }
    } catch (e) {
      console.log("Error:", e);
    }
  }


  const handleQuestionChange = async (questionRoot, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
    try {
      if (questionRoot.idQuestion === 685 && answer?.idAnswerOption === 4629) {
        const address = await handleSearchClientAddress(clientCnpj.current);

        setFilteredQuestionnaire(filteredQuestionnaire.map(question => {
          if (question.idQuestion === 666 && address.cep) {
            address.cep = `${address.cep}`.padStart(8, '0');
            setFieldValue && setFieldValue(question.key, address.cep);
            return ({ ...question, answer: address.cep, answerJson: undefined });
          }

          if (question.idQuestion === 667 && address.logradouro) {
            console.log(question.idQuestion, address.logradouro)
            setFieldValue && setFieldValue(question.key, address.logradouro);
            return ({ ...question, answer: address.logradouro, answerJson: undefined });
          }

          if (question.idQuestion === 670 && address.municipio) {
            console.log(question.idQuestion, address.municipio?.descricao)
            setFieldValue && setFieldValue(question.key, address.municipio?.descricao);
            return ({ ...question, answer: address.municipio?.descricao, answerJson: undefined });
          }

          if (question.idQuestion === 671) {
            console.log(question.idQuestion, address.uf)
            setFieldValue && setFieldValue(question.key, address.uf);
            return ({ ...question, answer: address.uf, answerJson: undefined });
          }

          if (question.idQuestion === 668) {
            console.log(question.idQuestion, address.numero)
            setFieldValue && setFieldValue(question.key, address.numero);
            return ({ ...question, answer: address.numero, answerJson: undefined });
          }

          return question;
        }))
      }

      if (questionRoot.idQuestion === 687) {

        const formatedDate = answer.split('/').reverse().join('-');
        const endOfTerm = moment(new Date(formatedDate)).utcOffset(3).add(1, 'y');

        setFilteredQuestionnaire(filteredQuestionnaire.map(qst => {
          if (qst.idQuestion === 731) {
            setFieldValue && setFieldValue(qst.key, endOfTerm.format('DD/MM/YYYY'));
            return ({ ...qst, answer: endOfTerm.format('YYYY-MM-DD') });
          }
          return qst;
        }));
      }
    } catch (e) {
      console.log("Error:", e);
    }
  }
  useEffect(() => {
    buildValidation();
  }, [questionnaire]);


  useEffect(() => {
    async function start() {
      try {
        handleOperationInfo();
        useGetDocumentsRequest(null, { idDomain: 261 });
        await useGetQuestionnairesAnswersRequest();
      } catch (e) {
        updateIsLoadingStatus(false);
      }
    }
    start();
  }, [])

  const handleSaveQuestionnaireAnswer = (values, idOperation, onlyQuestions) => {
    const formValues = JSON.parse(JSON.stringify(values));

    const body = { questionnaireAnswers: [] };
    for (const [key, section] of Object.entries(SECTIONS)) {
      if (section.isMultiple) {
        let multipleFields = []
        switch (section.name) {
          case 'INFORMATION':
            multipleFields = information;
            break;
          case 'PARCELAMENTO':
            multipleFields = installments;
            break;
          default:
            multipleFields = [];
            break;
        }

        multipleFields.map((field, index) => {
          let sectionAnswers = formValues[`$ANSWERS_${section.name}_${index}`];
          if (sectionAnswers?.length) {
            const rootQuestion = sectionAnswers.find(question => !question.idQuestionRoot);
            const childrenQuestions = sectionAnswers.filter(question => question.idQuestionRoot);
            rootQuestion.childrenQuestions = childrenQuestions
            if (!onlyQuestions) {
              body.questionnaireAnswers = [...body.questionnaireAnswers, rootQuestion];
            } else {
              body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
            }
          }
        })
      } else {
        let sectionAnswers = formValues[`$ANSWERS_${section.name}`];
        if (sectionAnswers) {
          body.questionnaireAnswers = [...body.questionnaireAnswers, ...sectionAnswers];
        }
      }
    }

    for (const question of body.questionnaireAnswers) {
      if ((question.idDomainQuestion === 270 || question.idDomainQuestion === 271) && question.answer) {
        try {
          question.answer = JSON.stringify(question.answer)
        } catch (e) {
        }
      }
    }

    if (onlyQuestions) return body.questionnaireAnswers;

    let total = 0;
    for (const question of body.questionnaireAnswers) {
      if (question.idQuestion === 726) total += Number(question?.childrenQuestions.find(qs => qs.idQuestion === 691)?.answer) || 0;
    }

    if (total > 99) return mc.error('A participação dos co-corretores deve totalizar no máximo 99%!');

    useSaveQuestionnaireAnswerRequest(body.questionnaireAnswers);
  }


  const termsModal = () => (
    <DialogComponent title={dialogTerms.title} size='80%' show={dialogTerms.visible} setDialog={setDialogTerms}>
      <ContentCard title="Termos e Condições: " noBorder>

        <TermText>Declaro que as informações acima são verdadeiras e que estou ciente de que, em caso de sinistro, se for verificado que as informações, que serviram de base para a contratação e fixação do custo do seguro, forem inexatas, a indenização poderá ser reduzida ou negada pela seguradora.</TermText>
        <TermText>A empresa proponente deve notificar a seguradora, o mais rápido possível, sobre qualquer alteração das informações contidas neste questionário, ocorridas antes do início da vigência do seguro. Nesse caso, a seguradora poderá, a seu critério, modificar ou cancelar a cotação de seguro anteriormente enviada.</TermText>
        <TermText>A seguradora fica autorizada a fazer qualquer investigação ou pergunta relacionada ao risco, na medida em que julgue necessária.</TermText>

        <Row className='justify-content-end'>
          <Col xs={3}>
            <Button
              id="btnContinue"
              type="button"
              onClick={() => {
                setDialogTerms({ ...dialogTerms, visible: false })
                setTerms((prev) => ({ ...prev, termsAndConditions: true }))
              }}
              secundary
            >
              ACEITAR
            </Button>
          </Col>
        </Row>
      </ContentCard>
    </DialogComponent>
  )

  const PMT = (rate, nper, pv, fv, type) => {
    if (!fv) fv = 0;
    if (!type) type = 0;

    if (rate == 0) return (pv + fv) / nper;

    var pvif = Math.pow(1 + rate, nper);
    var pmt = rate / (pvif - 1) * (pv * pvif + fv);

    if (type == 1) {
      pmt /= (1 + rate);
    };

    return pmt;
  }

  const handleGenerateInstallments = (question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => {
    if (question.idQuestion === 684) {
      if (answer) {
        let idsAnswersToDelete = [];
        for (const group of installments) {
          idsAnswersToDelete = [
            ...idsAnswersToDelete,
            ...questionnaireAnswersToDelete,
            ...group.map(qst => (
              qst.idQuestionnaireAnswers
            )).filter(idQuestionnaireAnswers => idQuestionnaireAnswers)
          ]
        }

        setQuestionnaireAnswersToDelete(idsAnswersToDelete);
        setVisibleSection(true);

        const coverageAmount = coverageCalcList[coverageOption].coverageAmount;
        const numberOfInstallments = question.answerOptions.find(
          opt => opt.idAnswerOption === answer.idAnswerOption
        ).sequenceAnswer;
        const installmentValue = PMT(
          +answer.resultValue,
          numberOfInstallments,
          coverageAmount
        );

        const newInstallments = [];
        for (var i = 1; i <= numberOfInstallments; i++) {
          const installmentNumber = JSON.parse(JSON.stringify(installments[0].find(qst => qst.idQuestion === 1217)));
          const total = JSON.parse(JSON.stringify(installments[0].find(qst => qst.idQuestion === 1218)));
          const dueDate = JSON.parse(JSON.stringify(installments[0].find(qst => qst.idQuestion === 1219)));
          installmentNumber.key = null;
          installmentNumber.idQuestionnaireAnswers = null;
          total.key = null;
          total.idQuestionnaireAnswers = null;
          dueDate.key = null;
          dueDate.idQuestionnaireAnswers = null;

          installmentNumber.answer = String(i);
          total.answer = String(installmentValue);
          dueDate.answer = '';

          if (i === 1) {
            const mask = total.fieldMask;
            const masked = IMask.createMask(mask);

            setTotalInstallments(
              `R$ ${masked.resolve(String(installmentValue * numberOfInstallments).replace('.', ','))}`
            );
          }

          const installment = [installmentNumber, total, dueDate];
          newInstallments.push(installment);
        }

        setInstallments(newInstallments);
      } else {
        let idsAnswersToDelete = [];
        for (const group of installments) {
          idsAnswersToDelete = [
            ...idsAnswersToDelete,
            ...questionnaireAnswersToDelete,
            ...group.map(qst => (
              qst.idQuestionnaireAnswers
            )).filter(idQuestionnaireAnswers => idQuestionnaireAnswers)
          ]
        }

        setQuestionnaireAnswersToDelete(idsAnswersToDelete);
        setVisibleSection(false);

        const installmentNumber = JSON.parse(JSON.stringify(installments[0].find(qst => qst.idQuestion === 1217)));
        const total = JSON.parse(JSON.stringify(installments[0].find(qst => qst.idQuestion === 1218)));
        const dueDate = JSON.parse(JSON.stringify(installments[0].find(qst => qst.idQuestion === 1219)));
        installmentNumber.key = null;
        installmentNumber.idQuestionnaireAnswers = null;
        installmentNumber.answer = '';
        total.key = null;
        total.idQuestionnaireAnswers = null;
        total.answer = '';
        dueDate.key = null;
        dueDate.idQuestionnaireAnswers = null;
        dueDate.answer = '';

        const installment = [installmentNumber, total, dueDate];

        setInstallments([installment]);
      }
    }
  }

  return (
    <Layout
      title={"Analise da Cotação"}
      subtitle={`${operation?.productName || ""}`}
    >
      {termsModal()}
      <Row>
        <Col>
          <StepNavigation
            stage={2}
            idOperation={props.match?.params?.idOperation}
            idProduct={props.match?.params?.idProduct}
            permissions={permissions}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <BrokingSummary
            history={history}
            idOperation={props.match?.params?.idOperation}
            idProduct={props.match?.params?.idProduct} />
        </Col>
      </Row>

      <Content>
        <Formik
          innerRef={formikRef}
          initialValues={{}}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
          onSubmit={values => hire(values)}
        >
          {({ values, setFieldValue, errors, setFieldError }) => {
            return (
              <Form>

                <Row>
                  <Col md={4} >
                    {(coverageCalcList && coverageCalcList[coverageOption]) && (
                      <>
                        <TitleBar>
                          <TitleInfo>OPÇÃO {coverageOption + 1}</TitleInfo>
                          {!isBound && <TitleAlter onClick={() => { history.push(`/quote/plans/${operation?.idProduct}/${props.match?.params?.idOperation}`) }}>Alterar</TitleAlter>}
                        </TitleBar>
                        <OptionSummary>
                          <OptionSummaryTitle>Importância Segurada</OptionSummaryTitle>
                          <OptionSummaryValue bold>
                            R$ {maskHelper.formatCurrency(authContext, coverageCalcList[coverageOption].coverageLimit)}
                          </OptionSummaryValue>

                          <OptionSummaryTitle>Prêmio líquido</OptionSummaryTitle>
                          <OptionSummaryValue>
                            R$ {maskHelper.formatCurrency(authContext, coverageCalcList[coverageOption].coverageAmountTaxLess)}
                          </OptionSummaryValue>

                          <OptionSummaryTitle>IOF</OptionSummaryTitle>
                          <OptionSummaryValue>
                            R$ {maskHelper.formatCurrency(authContext, coverageCalcList[coverageOption].coverageTax)}
                          </OptionSummaryValue>

                          <OptionSummaryTitle>Prêmio Total (Valor a ser pago)</OptionSummaryTitle>
                          <OptionSummaryValue bold>
                            R$ {maskHelper.formatCurrency(authContext, coverageCalcList[coverageOption].coverageAmount)}
                          </OptionSummaryValue>
                        </OptionSummary>
                      </>)
                    }
                  </Col>

                  <Col md={8} >
                    <Row>
                      <Col>
                        <TitleBar>
                          <TitleInfo>DADOS DE PAGAMENTO</TitleInfo>
                        </TitleBar>
                        <OptionSummary>
                          <FormSection
                            disableAll={isBound}
                            sectionName="OPERATION_INFO"
                            questionnaire={questionnaire}
                            values={values}
                            setFieldValue={setFieldValue}
                            formikRef={formikRef}
                            idOperationParent={props.match?.params?.idOperationParent}
                            idProduct={props.match.params.idProduct}
                            onQuestionChange={function (question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) {
                              handleQuestionChange(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue)
                            }}
                            errors={errors}
                            setFieldError={setFieldError}
                            ignoreModality
                            permissions={permissions}
                          />
                          {information.map((questions, index) => (
                            <>
                              <FormSection
                                disableAll={isBound}
                                sectionName="INFORMATION"
                                sectionIndex={index}
                                questionnaire={questions}
                                values={values}
                                formikRef={formikRef}
                                extraButtons={() => renderAddAndRemoveButtons(information, index, questions, setInformation, "$ANSWERS_CO-PERSON-EXG", values)}
                                idOperation={props.match?.params?.idOperation}
                                idOperationParent={props.match?.params?.idOperationParent}
                                idProduct={props.match.params.idProduct}
                                errors={errors}
                                setFieldValue={setFieldValue}
                                setFieldError={setFieldError}
                                ignoreModality
                                onQuestionChange={function (question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) {
                                  handleInformationSection(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue);
                                }}
                                permissions={permissions}
                              />
                            </>)
                          )}
                          <ContentCard
                            icon
                            title="Dados do Segurado"
                            info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
                            <FormSection
                              disableAll={isBound}
                              sectionName="INSURED"
                              questionnaire={questionnaire}
                              values={values}
                              setFieldValue={setFieldValue}
                              formikRef={formikRef}
                              idOperationParent={props.match?.params?.idOperationParent}
                              idProduct={props.match.params.idProduct}
                              onSearchZipCode={(zipCode, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) => handleSearchZipCode(zipCode, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue)}
                              onQuestionChange={function (question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue) {
                                handleQuestionChange(question, answer, filteredQuestionnaire, setFilteredQuestionnaire, setFieldValue)
                              }}
                              errors={errors}
                              setFieldError={setFieldError}
                              ignoreTypeOfApplication
                              permissions={permissions}
                            />
                          </ContentCard>
                          <ContentCard
                            icon
                            title="Informação de Pagamento"
                            info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}>
                            <FormSection sectionName="PAYMENT"
                              disableAll={isBound}
                              questionnaire={questionnaire}
                              values={values}
                              formikRef={formikRef}
                              idOperationParent={props.match?.params?.idOperationParent}
                              idProduct={props.match.params.idProduct}
                              errors={errors}
                              setFieldValue={setFieldValue}
                              setFieldError={setFieldError}
                              ignoreModality
                              permissions={permissions}
                              onQuestionChange={(
                                question,
                                answer,
                                filteredQuestionnaire,
                                setFilteredQuestionnaire,
                                setFieldValue
                              ) => handleGenerateInstallments(
                                question,
                                answer,
                                filteredQuestionnaire,
                                setFilteredQuestionnaire,
                                setFieldValue
                              )}
                            />
                          </ContentCard>

                          {visibleSection &&
                            <ContentCard title="Resumo de pagamento">
                              {installments && installments.map((questions, index) => (
                                <FormSection
                                  key={index}
                                  sectionName={'PARCELAMENTO'}
                                  values={values}
                                  errors={errors}
                                  sectionIndex={index}
                                  setFieldValue={setFieldValue}
                                  setFieldError={setFieldError}
                                  questionnaire={questions}
                                  disableAll={isBound}
                                  formikRef={formikRef}
                                  ignoreModality
                                  permissions={permissions}
                                />
                              ))}
                              <b style={{ textAlign: 'right' }}>Total à pagar: {totalInstallments}</b>
                            </ContentCard>
                          }
                        </OptionSummary>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <TermsContainer>
                          <CheckBox
                            disabled={isBound}
                            checked={terms.authorization}
                            onChange={() => setTerms((prev) => ({ ...prev, authorization: !prev.authorization }))}
                          />
                          <Term>
                            Confirmo que Revisei os Dados Preenchidos e Autorizo a Emissão do Seguro.
                          </Term>
                        </TermsContainer>
                        <TermsContainer>
                          <CheckBox
                            disabled={isBound}
                            checked={terms.termsAndConditions}
                            onChange={() => setTerms((prev) => ({ ...prev, termsAndConditions: !prev.termsAndConditions }))}
                          />
                          <Term>
                            Concordo que Li e Aceito os <StrongTerm onClick={() => setDialogTerms((prev) => ({ ...prev, visible: true }))}>Termos e Condições</StrongTerm> apresentados.
                          </Term>
                        </TermsContainer>
                      </Col>
                    </Row>
                  </Col>
                </Row>


                <ButtonContainer style={{ marginTop: 60 }}>
                  <Button forth style={{ width: 'auto' }} onClick={() => handleBack()}> &lt; VOLTAR </Button>
                  <ButtonContent>
                    <HasPermission permission={!isBound && permissions.MARKETS_SELECTION}>
                      <Button
                        id="btnSave"
                        type="button"
                        style={{ marginLeft: 15 }}
                        // @ts-ignore
                        onClick={() => {
                          validationSchema.current.validate(values)
                            .then(() => {
                              hire(values, true)
                              mc.success("Informações de Pagamento salvas com sucesso.");
                              history.push(`/enquiries`)
                            })
                            .catch((e) => {
                              console.log('validation error', e)
                              mc.error('Por favor, preencha todos os campos obrigatórios (*)')
                            })
                        }}
                        primary
                      >
                        SALVAR
                      </Button>
                    </HasPermission>
                    <HasPermission permission={!isBound && permissions.ORDER_TO_BIND_GENERATE}>
                      <Button
                        id="btnSave"
                        type="submit"
                        style={{ marginLeft: 15 }}
                        // @ts-ignore
                        onClick={() => {
                          validationSchema.current.validate(values).catch((e) => {
                            console.log('validation error', e)
                            mc.error('Por favor, preencha todos os campos obrigatórios (*)')
                          })
                        }}
                        secundary
                      >
                        EFETIVAR SEGURO
                      </Button>
                    </HasPermission>
                  </ButtonContent>
                </ButtonContainer>
              </Form>
            )
          }}
        </Formik>
      </Content>
    </Layout >
  )
}
